import { BaseDto } from "../common/baseDto";

export interface ItemDto extends BaseDto {
  itemCd: string;
  itemNm: string;
  modelNo: string;
  itemSpec: string;
  itemUnit: string;
  brandCd: string;
  itemGroup: string;
  itemAccount: string;
  stockQty: number;
  itemCost: number;
  workCost: number;
  stockAmount: number;
  locationCd: string;
  locationNm: string;
  locationCd2: string;
  purQty: number;
  packQty: number;
  salQty: number;
  itemImage: string;
  itemImage2: string;
  customCd: string;
  customNm: string;
  customItemcd: string;
  equipmentCd: string;
  equipmentNm: string;
  prodStockType: string;
  inspectYn: string;

  remark: string;

  inserted: boolean;
  isModified: boolean;
}

export const defaultItem: ItemDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	itemCd: '',
	itemNm: '',
	modelNo: '',
	itemSpec: '',
	itemUnit: '',
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	stockQty: 0,
	itemCost: 0,
	workCost: 0,
	stockAmount: 0,
	locationCd: '',
	locationNm: '',
	locationCd2: '',
	purQty: 0,
	packQty: 0,
	salQty: 0,
	itemImage: '',
	itemImage2: '',
	customCd: '',
	customNm: '',
	customItemcd: '',
	equipmentCd: '',
	equipmentNm: '',
	prodStockType: 'I',
	inspectYn: 'Y',
	remark: '',

	inserted: false,
	isModified: false
}
